import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import USER_MANAGEMENT_CONTROLLER, { ADD_USER_BLOCK_STATE, getAddUserBlockState } from '../../controllers/userManagement';
import BusySpinner from '../spinners/BusySpinner';
import AddUser from './AddUser';

// Keeps the Add User form unmounted unless the customer is confirmed not to be linked to an IAM tenant,
// covering the button, typed URLs, bookmarks and back/forward navigation.
export const AddUserRouteGuard = ({ addUserBlockState, onLoadIamTenantInfo, ...props }) => {

    useEffect(() => {
        onLoadIamTenantInfo();
    }, []);

    if (addUserBlockState === ADD_USER_BLOCK_STATE.ALLOWED) {
        return <AddUser {...props} />;
    }
    if (addUserBlockState === ADD_USER_BLOCK_STATE.BLOCKED) {
        return <Redirect to="/UserManagement" />;
    }
    return <BusySpinner busy={true} />;
};

/* istanbul ignore next */
export function mapStateToProps(state) {
    return {
        addUserBlockState: getAddUserBlockState(state)
    };
}

/* istanbul ignore next */
export function mapDispatchersToProps(dispatch) {
    return {
        onLoadIamTenantInfo: () => {
            dispatch(USER_MANAGEMENT_CONTROLLER.doLoadIamTenantInfo());
        }
    };
}

export default connect(mapStateToProps, mapDispatchersToProps)(AddUserRouteGuard);
